import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useRouter } from '@tanstack/react-router';

/**
 * Sync form values to search params
 *
 * @param to - The route to navigate to
 * @example
 * ```tsx
 * useFormSearchParams('/app/model-runs');
 * ```
 */
export function useFormSearchParams<T extends Record<string, string>>(
  to: string
) {
  const router = useRouter();
  const { watch } = useFormContext<T>();

  useEffect(() => {
    const { unsubscribe } = watch(async (search) => {
      await router.navigate({
        to,
        search: { ...search } as T,
      });
    });
    return () => {
      unsubscribe();
    };
  }, [router, to, watch]);
}
